module.exports = __webpack_public_path__ + "img/masterreno.a30c042c.svg";